import Home from "../../views/administrador/Home";



///----------VENTAS----------------
import Entrega from "../../views/administrador/Ventas/Entrega";
import EntregaCombustible from "../../views/administrador/Ventas/EntregaCombustible";
import FacturasFfacsa from "../../views/administrador/Ventas/FacturasFfacsa";

//----------PRODUCCION-------------
import ControlTiemposMuertos from "../../views/administrador/Produccion/ControlTiemposMuertos";
import Liberar_lotes from "../../views/administrador/Produccion/Liberar_lotes";
import Calculo_Resistencias from "../../views/administrador/Produccion/Calculo_Resistencias";
import ValidarCalculo_Resistencias from "../../views/administrador/Produccion/ValidarCalculo_Resistencias";
import CalculoGranulometria from "../../views/administrador/Produccion/CalculoGranulometria";
import CertificadosCalidad from "../../views/administrador/Produccion/CertificadosCalidad";
import CertificadosGenerados from "../../views/administrador/Produccion/CertificadosGenerados";
import AdministrarCertificadosCalidad from "../../views/administrador/Produccion/AdministrarCertificadosCalidad";

//----------COMPRAS-------------
import Solicitud_Compras_Servicio from "../../views/administrador/Compras/Solicitud_Compras_Servicio";
import Solicitud_Compras from "../../views/administrador/Compras/Solicitud_Compras";
import Solicitud_Compras_ADM from "../../views/administrador/Compras/Solicitud_Compras_ADM";
import Solicitud_Compras_Servicio_ADM from "../../views/administrador/Compras/Solicitud_Compras_Servicio_ADM";
import Informe_de_estatus_de_autorizacion from "../../views/administrador/Compras/Informe_de_estatus_de_autorizacion";
import RequiAdjunto from "../../views/administrador/Compras/RequiAdjunto";

//----------AUTORIZACIOINES-------------
import Autorizaciones_compras from "../../views/administrador/Autorizaciones/Autorizaciones_compras";
import Autorizaciones_comprasV2 from "../../views/administrador/Autorizaciones/Autorizaciones_comprasv2";

//----------FRACTTAL-------------
import Interface from "../../views/administrador/Fracttal/Interface";

//----------LOGISTICA-------------
import FfactSAP from "../../views/administrador/Logistica/FfactSAP";

//----------BODEGA-------------
import SolicitudTraslado from "../../views/administrador/Bodega/SolicitudTraslado";
import TransferenciaStock from "../../views/administrador/Bodega/TransferenciaStock";
import Inventario from "../../views/administrador/Bodega/Inventario";
import Tags from "../../views/administrador/Bodega/Tags";
import InformeInventario from "../../views/administrador/Bodega/InformeInventario";
import EntradaMercancias from "../../views/administrador/Bodega/EntradaMercancias";
import Entregas from "../../views/administrador/Bodega/Entregas";



const FinanzasRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "pe-7s-home",
    component: Home,
    id: "1",
  },

  // --------------- Ventas -------------
  {
    path: 3,
    name: "Ventas",
    icon: "pe-7s-cash",
    id: "3",
    component: [
      {
        path: "/Entrega",
        name: "Entrega",
        icon: "",
        component: Entrega,
        doNotShow: true,
        id: "3",
        grupoDependiente: 3,
      },  
      {
        path: "/EntregaCombustible",
        name: "Entrega Combustible",
        icon: "",
        component: EntregaCombustible,
        doNotShow: true,
        id: "3000",
        grupoDependiente: 3,
      },    
      {
        path: "/FacturasFfacsa",
        name: "Facturas Ffacsa",
        icon: "",
        component: FacturasFfacsa,
        doNotShow: true,
        id: "3001",
        grupoDependiente: 3,
      },  
    ],
  }, 
  
  // --------------- Produccion -------------
  {
    path: 2,
    id: "2",
    name: "Produccion",
    icon: "pe-7s-display1",
    component: [
      {
        path: "/ControlTiemposMuertos",
        name: "Tiempos Muertos",
        icon: "",
        component: ControlTiemposMuertos,
        doNotShow: true,
        id: "2",
        grupoDependiente: 2,
      },   
      {
        path: "/Liberar_lotes",
        name: "Liberar Lotes",
        icon: "",
        component: Liberar_lotes,
        doNotShow: true,
        id: "4000",
        grupoDependiente: 2,
      },
      {
        path: "/Calculo_Resistencias",
        name: "Calculo de Resistencias",
        icon: "",
        component: Calculo_Resistencias,
        doNotShow: true,
        id: "4001",
        grupoDependiente: 2,
      },     
      {
        path: "/ValidarCalculo_Resistencias",
        name: "Validar Calculo Resistencias",
        icon: "",
        component: ValidarCalculo_Resistencias,
        doNotShow: true,
        id: "4002",
        grupoDependiente: 2,
      }, 
      {
        path: "/CalculoGranulometria",
        name: "Calculo Granulometria",
        icon: "",
        component: CalculoGranulometria,
        doNotShow: true,
        id: "4003",
        grupoDependiente: 2,
      }, 
      {
        path: "/CertificadosCalidad",
        name: "Certificados de Calidad",
        icon: "",
        component: CertificadosCalidad,
        doNotShow: true,
        id: "4004",
        grupoDependiente: 2,
      }, 
       
      {
        path: "/CertificadosGenerados",
        name: "Buzon de Certificados",
        icon: "",
        component: CertificadosGenerados,
        doNotShow: true,
        id: "4005",
        grupoDependiente: 2,
      }, 

      {
        path: "/AdministrarCertificadosCalidad",
        name: "Administrar Certificados de Calidad",
        icon: "",
        component: AdministrarCertificadosCalidad,
        doNotShow: true,
        id: "4006",
        grupoDependiente: 2,
      }, 
     
    ],
  },
  
  // --------------- Compras  -------------
  {
    path: 11,
    name: "Compras",
    icon: "pe-7s-cart",
    id: "11",
    component: [
      {
        path: "/Solicitud_Compras_Servicio",
        name: "Solicitud de Servicio Preliminar",
        icon: "",
        component: Solicitud_Compras_Servicio,
        doNotShow: true,
        id: "1001",
        grupoDependiente: 11,
      },     
      {
        path: "/Solicitud_Compras",
        name: "Solicitud de Articulo Preliminar",
        icon: "",
        component: Solicitud_Compras,
        doNotShow: true,
        id: "1002",
        grupoDependiente: 11,
      },  
      {
        path: "/Solicitud_Compras_ADM",
        name: "Solicitud Compra por Articulo",
        icon: "",
        component: Solicitud_Compras_ADM,
        doNotShow: true,
        id: "1003",
        grupoDependiente: 11,
      },  
      {
        path: "/Solicitud_Compras_Servicio_ADM",
        name: "Solicitud Compra Servicio",
        icon: "",
        component: Solicitud_Compras_Servicio_ADM,
        doNotShow: true,
        id: "1004",
        grupoDependiente: 11,
      }, 
      {
        path: "/Informe_de_estatus_de_autorizacion",
        name: "Informe status de autorizacion",
        icon: "",
        component: Informe_de_estatus_de_autorizacion,
        doNotShow: true,
        id: "1005",
        grupoDependiente: 11,
      }, 
      {
        path: "/RequiAdjunto",
        name: "Adjuntar Archivo Cotizacion",
        icon: "",
        component: RequiAdjunto,
        doNotShow: true,
        id: "1006",
        grupoDependiente: 11,
      }, 
    ],
  },

   // --------------- Autorizaciones  -------------
   {
    path: 12,
    name: "Autorizaciones Compras",
    icon: "pe-7s-check",
    id: "12",
    component: [
      {
        path: "/Autorizaciones_compras",
        name: "Autorizaciones Compras",
        icon: "",
        component: Autorizaciones_compras,
        doNotShow: true,
        id: "2001",
        grupoDependiente: 12,
      },     
      {
        path: "/Autorizaciones_comprasV2",
        name: "Autorizaciones Compras V2",
        icon: "",
        component: Autorizaciones_comprasV2,
        doNotShow: true,
        id: "2002",
        grupoDependiente: 12,
      },  
    ],
  },

   // --------------- Interface  -------------
   {
    path: 13,
    name: "Interface",
    icon: "pe-7s-rocket",
    id: "13",
    component: [
      {
        path: "/Interface",
        name: "Interface",
        icon: "",
        component: Interface,
        doNotShow: true,
        id: "5000",
        grupoDependiente: 13,
      },     
    ],
  },


  // --------------- Logistica  -------------
   {
    path: 14,
    name: "Logistica",
    icon: "pe-7s-map-2",
    id: "14",
    component: [
      {
        path: "/FfactSAP",
        name: "Ingresar Factura FFACSA",
        icon: "",
        component: FfactSAP,
        doNotShow: true,
        id: "6000",
        grupoDependiente: 14,
      },     
    ],
  },


    // --------------- Bodega  -------------
   {
    path: 15,
    name: "Bodega",
    icon: "pe-7s-box1",
    id: "15",
    component: [
      {
        path: "/SolicitudTraslado",
        name: "Solicitud de Traslado",
        icon: "",
        component: SolicitudTraslado,
        doNotShow: true,
        id: "7000",
        grupoDependiente: 15,
      },     
      {
        path: "/TransferenciaStock",
        name: "Transferencias de Stock",
        icon: "",
        component: TransferenciaStock,
        doNotShow: true,
        id: "7001",
        grupoDependiente: 15,
      }, 
      {
        path: "/Inventario",
        name: "Inventario",
        icon: "",
        component: Inventario,
        doNotShow: true,
        id: "7002",
        grupoDependiente: 15,
      }, 
      {
        path: "/Tags",
        name: "Tags",
        icon: "",
        component: Tags,
        doNotShow: true,
        id: "7003",
        grupoDependiente: 15,
      },   
      {
        path: "/InformeInventario",
        name: "Informe Inventario",
        icon: "",
        component: InformeInventario,
        doNotShow: true,
        id: "7004",
        grupoDependiente: 15,
      },   
      {
        path: "/EntradaMercancias",
        name: "Entrada de Mercancias",
        icon: "",
        component: EntradaMercancias,
        doNotShow: true,
        id: "7005",
        grupoDependiente: 15,
      },  
      {
        path: "/Entregas",
        name: "Entregas",
        icon: "",
        component: Entregas,
        doNotShow: true,
        id: "7006",
        grupoDependiente: 15,
      },  
    ],
  },
];
export default FinanzasRoutes;
